<template>
  <v-row class="mx-0 px-0 dense pb-0">
    <v-col cols="12" class="pb-0 px-0" md="7">
      <v-card-subtitle class="px-0 text--black">
        Provide access to your event partner/key participant so they can establish their Pappyon account. This will enable them to complete the setup of their Featured Profile including inviting their representatives to join your event.
      </v-card-subtitle>
      <v-row>
        <v-col cols="12" class="pb-4">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              Status
            </div>
          </v-col>
          <v-chip v-if="currentSponsor.status" class="mt-2">
              {{ currentSponsor.status }}
          </v-chip>
        </v-col>
        <v-col cols="6" class="pb-0">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              First Name
            </div>
          </v-col>
          <v-text-field :readonly="isFormReadOnly" outlined dense :rules="requiredRules" validate-on-blur placeholder="First Name" v-model="currentSponsor.firstName"></v-text-field>
        </v-col>
        <v-col cols="6" class="pb-0">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              Last Name
            </div>
          </v-col>
          <v-text-field :readonly="isFormReadOnly" outlined dense :rules="requiredRules" validate-on-blur placeholder="Last Name" v-model="currentSponsor.lastName"></v-text-field>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              Email
            </div>
          </v-col>
          <v-text-field :readonly="isFormReadOnly" outlined dense :rules="requiredRules" validate-on-blur placeholder="Email" v-model="currentSponsor.email"></v-text-field>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              Promo Code
            </div>
          </v-col>
          <v-text-field :readonly="isFormReadOnly" outlined dense validate-on-blur placeholder="Promo Code"
                        v-model="currentSponsor.promoCode"></v-text-field>
        </v-col>
      </v-row>


    </v-col>
  </v-row>

</template>


<script>
import Sponsor from "@/models/Sponsor";

export default {
  props: {
    currentSponsor: {
      type: Sponsor,
      required: true
    },
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
    };
  },
  computed: {
    isFormReadOnly() {
      return this.currentSponsor.status === "Registered" || this.currentSponsor.status === "Onboarded";
    },
  },
}

</script>